// src/modules/admin-panel/pages/login/auth.saga.ts
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { CONSTANTS } from 'utils';
import { AxiosResponse } from 'axios';
import { IRequestParams, request } from 'helpers/request';
import { getUserData } from './auth.actions';
import { IAuthData } from './models';
import * as types from './ActionTypes';
import { getUserDetailsSaga } from '../settings/sagas/settings.saga';

function* getUserDataSaga(): SagaIterator {
	try {
		yield put(getUserData.loading());

		// Auth is now handled by oidc-client-ts before this saga runs.
		// This saga is only responsible for fetching the user's
		// application-level profile (role, partnerId etc.) from your API.
		const signInParams: IRequestParams = {
			url: `${CONSTANTS.baseApiPath}${CONSTANTS.moduleAdminPath}/users/current`,
		};
		const data: AxiosResponse<IAuthData> = yield call(request, signInParams);

		yield call(getUserDetailsSaga);
		yield put(getUserData.success(data.data));
	} catch (e) {
		yield put(getUserData.fail(e));
	}
}

export function* authorizationSaga(): SagaIterator {
	yield all([takeEvery(types.GET_USER_DATA.DEFAULT, getUserDataSaga)]);
}
